import React, { FC } from 'react'
import { makeStyles, Button, Theme } from '@material-ui/core'
import { ArrowBack, MailOutline } from '@material-ui/icons'
import { Video } from 'components/shared'

import { E3DDemoNameVals, GameFlowSteps, IDemoCollection } from 'types'

import Logo from 'assets/nokia-verizon-logo.png'

interface RoboEvolutionProps {
  setScene: (step: GameFlowSteps) => void
}

export const RoboEvolution: FC<RoboEvolutionProps> = ({ setScene }) => {
  const classes = useStyles()

  const actionClicked = (action: 'explore' | 'connect' | 'demo') => {
    switch (action) {
      case 'explore':
        setScene(GameFlowSteps.BackToExplore)
        break
      case 'connect':
        window.postMessage('{"command":"connect", "param":"roboEvolution"}', '*')
        break
      case 'demo':
        window.postMessage(JSON.stringify({ command: 'demos', param: E3DDemoNameVals.ybvr }), '*')
        break
    }
  }
  return (
    <div className={classes.root}>
      <img src={Logo} alt='Nokia | Verizon' className={classes.logo} />
      <Video
        videoSrc={process.env.PUBLIC_URL + '/assets/robo-evolution.mp4'}
        autoLoop={true}
        autoPlay={true}
        disableControls={true}
        className={classes.video}
      />
      <div className={classes.buttonContainer}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => {
            actionClicked('explore')
          }}
          style={{ marginRight: '2rem' }}
        >
          Back
        </Button>

        <Button startIcon={<MailOutline />} onClick={() => actionClicked('connect')}>
          Send a message
        </Button>

        <Button
          endIcon={<ArrowBack className={classes.forwardArrow} />}
          onClick={() => {
            actionClicked('demo')
          }}
          style={{ marginLeft: '2rem' }}
        >
          Next Demo
        </Button>
      </div>
    </div>
  )
}
//trying to re-commit
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    zIndex: 2000,
    backgroundColor: '#9fc4cf'
  },
  video: {
    width: '100%',
    '& .video-react': {
      backgroundColor: '#9fc4cf',
      height: '100% !important',
      position: 'fixed',
      top: 0,
      left: 0,
      overflow: 'hidden'
    },
    '& .video-react-video': {
      left: '-20px',
      top: '-97%',
      position: 'absolute',
      height: '300%',
      [theme.breakpoints.down('sm')]: {
        top: '-100%',
        left: 0
      }
    }
  },
  logo: {
    position: 'absolute',
    zIndex: 2010,
    top: 30,
    left: '3rem',
    [theme.breakpoints.down('md')]: {
      left: 0,
      top: 0,
      width: '35%'
    }
  },
  buttonContainer: {
    position: 'absolute',
    zIndex: 2010,
    bottom: 20,
    left: '4rem',
    '& button': {
      color: '#fff',
      marginTop: 0,
      marginBottom: 0
    },
    [theme.breakpoints.down('md')]: {
      left: 20,
      bottom: 8
    }
  },
  forwardArrow: {
    position: 'relative',
    WebkitTransform: 'rotate(180deg)',
    transform: 'rotate(180deg)',
    cursor: 'pointer'
  }
}))
